// Column ids — used by the column defs and by the sort payload.
export const CONTRACT_COLUMNS = Object.freeze({
  contractId: 'contractId',
  materialName: 'materialName',
  totalShipmentLinked: 'totalShipmentLinked',
  supplierName: 'supplierName',
  status: 'status',
  facilityName: 'facilityName',
  terminal: 'terminal',
  unitType: 'unitType',
  contractedQuantity: 'contractedQuantity',
  shippedQuantity: 'shippedQuantity',
  outstandingQuantity: 'outstandingQuantity',
  ghgEmissions: 'ghgEmissions',
  ghgEmissionSavings: 'ghgEmissionSavings',
  rawMaterialType: 'rawMaterialType',
  countryOfOrigin: 'countryOfOrigin',
  feedstockCategory: 'feedstockCategory',
  allocationPreference: 'allocationPreference',
  deliverBy: 'deliverBy',
  discrepancies: 'discrepancies',
});

// Column id → the sort value ContractOrderByField accepts; anything missing gets no sort arrow.
export const CONTRACT_SORT_FIELDS = Object.freeze({
  [CONTRACT_COLUMNS.contractId]: 'contractId',
  [CONTRACT_COLUMNS.deliverBy]: 'deliverBy',
  [CONTRACT_COLUMNS.contractedQuantity]: 'contractedQuantity',
});
